import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import errorBoundary, {
  ErrorBoundaryProps,
} from 'client/shared/decorators/error-boundary'

import {
  loadAuthorQuotes,
  QUOTES_SAMPLE,
} from 'client/bookmate/reducers/author-reducer'
import { getAuthorById } from 'client/bookmate/reducers/authors-reducer'
import InfiniteScroll from 'client/shared/blocks/infinite-scroll'

import { AuthorProps } from 'client/shared/types/author'

import { State as AuthorMetaState } from 'client/bookmate/reducers/author-reducer'
import { Dispatch, State as ConnectedState } from 'shared/types/redux'
import { Params } from 'client/shared/types/react-router'

import { ObservedAnalyticsState } from 'shared/tools/analytics-helper'
import List from '../blocks/list/list'
import { CardQuoteBox } from './card-quote-box'
import { LayoutColumn } from 'client/shared/blocks/layout-column/layout-column'
import { withI18n, withI18nProps } from '@lingui/react'
import MetaTitle from 'client/shared/blocks/meta-title/meta-title'
import { MetaDescription } from 'client/shared/blocks/meta-description/meta-description'

type Props = {
  dispatch: Dispatch
  author: AuthorProps
  authorMeta: AuthorMetaState
  params: Params
} & ErrorBoundaryProps &
  withI18nProps

class AuthorQuotesBox extends Component<Props, ObservedAnalyticsState> {
  load = (): void => {
    const {
      dispatch,
      authorMeta: {
        quotes: { nextPage, content },
      },
      params: { authorId },
    } = this.props

    if (content.length < QUOTES_SAMPLE) return

    return dispatch(
      loadAuthorQuotes({
        authorId,
        page: nextPage,
        per_page: QUOTES_SAMPLE,
        append: true,
      }),
    )
  }

  render(): JSX.Element | null {
    if (!this.props.author) return null
    const {
      authorMeta: {
        quotes: { content, nextPage },
      },
      author: { name, works_count },
      i18n,
    } = this.props

    const currentPage = nextPage - 1
    const description = i18n._('author.author_quotes_desc', {
      authorName: name,
    })
    const title = i18n._('author.author_quotes', {
      authorName: name,
      count: works_count,
    })
    return (
      <>
        <MetaTitle hasOgSuffix title={title} og={title} />
        <MetaDescription description={description} og={description} />
        <InfiniteScroll load={this.load} page={currentPage}>
          <LayoutColumn>
            <List>
              {content.map((quote, i) => (
                <CardQuoteBox as="li" quote={quote} key={i} isAuthorPage />
              ))}
            </List>
          </LayoutColumn>
        </InfiniteScroll>
      </>
    )
  }
}

const connectWrapper = connect((state: ConnectedState) => ({
  author: getAuthorById(state, state.author.uuid),
  authorMeta: state.author,
}))

const wrappers = compose(
  connectWrapper,
  errorBoundary,
  withI18n({ update: true }),
)

export default wrappers(AuthorQuotesBox)
